import React from "react";
import { createRoot } from "react-dom/client";
import "./utils/styles/index.scss";
import "./utils/styles/global.css";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import { store } from "./store/store";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import PopupProvider from "./components/Popup/PopupProvider";
import HeadMetaData from "./components/HeadMetaData/HeadMetaData";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const container = document.getElementById("root");
const root = createRoot(container);

// NOTE: React.StrictMode was intentionally removed. In development it mounts→unmounts→remounts every
// component once, which is incompatible with intro.js-react (its exit() is async), producing a
// duplicate "phantom" step-1 tooltip in the product tour. StrictMode is a no-op in production, so
// this only changes dev behavior; re-add it if/when the tour is reworked to be StrictMode-safe.
root.render(
  <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA}>
    <BrowserRouter>
      <Provider store={store}>
        <PopupProvider>
          <HeadMetaData />
          <App />
        </PopupProvider>
      </Provider>
    </BrowserRouter>
  </GoogleReCaptchaProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
